<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18PdYxa/tc-custom/9781467460828.jpg?1737195675118" alt="This image is the cover for the book Women Who Do"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Women Who Do
      </h1>
      <p class="bookDescription body article font2">
        <b>Meet the women who followed Jesus even when the Twelve failed. </b><br/>    <br/> To be a disciple is to follow Jesus. And that requires <i>action</i>. But in the Gospels, the disciples often falter. The Twelve even abandon Jesus at his crucifixion in many of the narratives. Yet it is female disciples who remain faithful to Jesus to the end. What do we make of this? <br/>  <br/> In <i>Women Who Do</i>, Holly J. Carey examines what it means to be a disciple—and contends that it’s the women who best embody discipleship in the Gospels. Carey describes the expectations and social roles for women in first-century Greco-Roman and Jewish contexts. Then she offers a close reading of each of the four Gospels, as well as Acts of the Apostles. What emerges is a cohesive narrative-critical case that the Twelve are not an equivalent group to the disciples. In fact, the Twelve are set as foils against the faithful, active, and often nameless disciples who populate the narratives—many of whom are women.  <br/>  <br/><i>Women Who Do</i> is essential reading for students and scholars seeking a fuller understanding of women’s roles in Jesus’s ministry. Carey’s argument not only clarifies the narrative of the Gospels but also raises questions about how the church conceives of women’s leadership today.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly J. Carey
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Holly J. Carey</B>&#160;is professor of biblical studies and chair of the Biblical Studies Department at Point University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6845b7b5